<template>
  <div>
    <h5 class="info-alert text-center mb-3">Shifts: granted/total</h5>
    <b-row v-if="isDataInShiftsData"
           align-h="around"
           style="text-align: center;">

      <b-col v-for="(value, environment) in shiftsData"
             :key="environment"
             class="col-spacing"
             cols="12"
             lg="auto"
             md="4"
             sm="6">
        <shifts-counter-view-single :environment="environment"
                                    :isManagementEvaluation="isManagementEvaluation"
                                    :value="value"/>
      </b-col>
    </b-row>

    <b-row v-else
           align-h="around">
      <b-col cols="auto">
        <h5>No data</h5>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import ShiftsCounterViewSingle from '@/components/shifts-counter/ShiftsCounterViewSingle';

  export default {
    name: 'ShiftsCounterView',
    components: { ShiftsCounterViewSingle },
    props: {
      isManagementEvaluation: {
        type: Boolean,
        required: true,
      },
      shiftsData: {
        type: Object,
        required: true,
      },
    },
    computed: {
      isDataInShiftsData() {
        return Object.keys(this.shiftsData).length > 0;
      },
    },
  };
</script>

<style lang="scss" scoped>

  .info-alert {
    color: $color-blue-info !important;
  }

  .col-spacing {
    @media only screen and (max-width: 575px) {
      margin-bottom: 3rem;
    }
  }

  .col-spacing:first-child {
    @media only screen and (max-width: 991px) {
      margin-bottom: 3rem;
    }
  }

  .col-spacing:last-child {
    margin-bottom: 0;
  }
</style>
